import type { ColumnType } from 'antd/lib/table/';
import { numberToString } from '@/std/format';
import type { ProdutoAlteracaoPreco } from '../../../../../produto/types/ProdutoAlteracaoPreco';

export const servicoTabHistoricoAlteracaoColumns: ColumnType<ProdutoAlteracaoPreco>[] = [
    {
        align: 'center',
        dataIndex: 'alp_data_insercao',
        ellipsis: true,
        responsive: ['lg'],
        sorter: true,
        title: 'Data de alteração',
        width: '7.5rem',
    },
    {
        align: 'center',
        dataIndex: 'alp_usuario_nome',

        ellipsis: true,
        responsive: ['lg'],
        sorter: true,
        title: 'Usuário',
        width: '7rem',
    },
    {
        align: 'center',
        dataIndex: 'alp_descricao',
        ellipsis: true,
        responsive: ['lg'],
        sorter: true,
        title: 'Produto',
        width: '7rem',
    },
    {
        align: 'right',
        dataIndex: 'alp_preco_antigo',
        ellipsis: true,
        render: (alp_preco_antigo) => numberToString(alp_preco_antigo, 'currency'),
        responsive: ['sm'],
        sorter: true,
        title: 'Preço antigo',
        width: '8.5rem',
    },
    {
        align: 'right',
        dataIndex: 'alp_preco_novo',
        ellipsis: true,
        render: (alp_preco_novo) => numberToString(alp_preco_novo, 'currency'),
        responsive: ['sm'],
        sorter: true,
        title: 'Preço novo',
        width: '8.5rem',
    },
];
